// config.tsx
const BASE_URL = process.env.REACT_APP_BASE_API;

if (!BASE_URL) {
    console.error('REACT_APP_BASE_API is missing! Check your .env file');
}

const config = {
    BASE_URL: BASE_URL as string
};

export default config;